import React from 'react';

export default function Content({ children }) {
  return <main id="maincontent">{children}</main>;
}
